export default __webpack_public_path__ + "static/media/telugu_h.da4c141a.png";